export default ({ get, checkStatus, toJSON }) => ({
  getLayout: (id) =>
    get(
      `universe/v2/home_page_blue_prints${
        id ? `?custom_home_page_layout_id=${id}` : ""
      }`,
    )
      .then((response) => {
        // If we receive one of these errors from backend when we have an ID,
        // it means that the admin is trying to preview a blueprint.
        // Therefore, we need to avoid processing the response with checkStatus()
        if (id && [204, 403, 404].includes(response?.status)) {
          return response;
        }

        return checkStatus({ response, method: "GET" });
      })
      .then(toJSON),
});
